import { UserType } from '@/entities/user/@x/support'
import { apiClient, Auth } from '@/shared/api'

import { TFAQCategories } from '../model/schema'

export const getFAQCategories = async ({
  userType,
}: {
  userType: UserType
}) => {
  const { data } = await apiClient.get<TFAQCategories>({
    endpoint: `/support/${userType}/faq-categories`,
    auth: Auth.NONE,
  })

  return data
}
